import React, {useState, useEffect} from 'react';
import {Segment, Divider, List, Icon, Input, Button, Accordion} from 'semantic-ui-react';
import moment from 'moment';

const CalendarSidebar = ({
  statusDict, filterStatus, onStatusClick, searchTerm, onSearchChange,
  agendas, selectedId, onSelect, onEdit, onView, onViewInscritos, canEdit, isMatriculaUser,
}) => {
  const [activeIndices, setActiveIndices] = useState([]);

  const activeStatuses = statusDict.filter((s) => s.status === 'A');

  const groupedAgendas = agendas.reduce((acc, curr) => {
    const name = curr.nombre_curso || 'Sin nombre';
    if (!acc[name]) {
      acc[name] = [];
    }
    acc[name].push(curr);
    return acc;
  }, {});

  const sortedGroups = Object.keys(groupedAgendas).sort().map((name) => ({
    'name': name,
    'items': groupedAgendas[name].sort((a, b) =>
      moment(a.start_date || a.desde).diff(moment(b.start_date || b.desde))),
  }));

  useEffect(() => {
    if (selectedId == null) {
      return;
    }
    const idx = sortedGroups.findIndex((g) => g.items.some((ag) => Number(ag.id) === Number(selectedId)));
    if (idx !== -1 && !activeIndices.includes(idx)) {
      setActiveIndices((prev) => [...prev, idx]);
    }
  }, [selectedId, sortedGroups]);

  const handleTitleClick = (e, titleProps) => {
    const {index} = titleProps;
    const newIndices = activeIndices.includes(index) ?
      activeIndices.filter((i) => i !== index) :
      [...activeIndices, index];
    setActiveIndices(newIndices);
  };

  return (
    <Segment raised style={{'height': '100%', 'display': 'flex', 'flexDirection': 'column'}}>
      <h4 className="ui dividing header">ESTADOS</h4>
      <List relaxed size="mini" style={{'marginBottom': '1em'}}>
        {activeStatuses.map((s) => {
          const isSelected = filterStatus === s.code;
          return (
            <List.Item
              key={s.code} onClick={() => onStatusClick(s.code)}
              style={{
                'cursor': 'pointer', 'borderRadius': '4px', 'padding': '5px',
                'backgroundColor': isSelected ? '#e2f9e2' : 'transparent',
              }}
            >
              <Icon
                name={isSelected ? 'check circle' : 'circle'}
                style={{'color': isSelected ? '#21ba45' : (s.hex || '#ccc')}}
              />
              <List.Content style={{'fontWeight': isSelected ? 'bold' : 'normal'}}>
                {s.course_status}
              </List.Content>
            </List.Item>
          );
        })}
      </List>
      <Divider />
      <h4 className="ui dividing header">LISTADO DE CURSOS</h4>
      <Input
        fluid icon={{'name': 'search', 'link': true, 'color': 'blue'}}
        iconPosition="left" placeholder="Buscar..."
        value={searchTerm} onChange={(e, {value}) => onSearchChange(value)}
        style={{'marginBottom': '1em'}} size="small"
      />
      <div style={{'flex': 1, 'overflowY': 'auto', 'paddingRight': '5px'}}>
        <Accordion fluid styled exclusive={false} style={{'boxShadow': 'none', 'border': '1px solid #efefef'}}>
          {sortedGroups.map((group, index) => (
            <React.Fragment key={group.name}>
              <Accordion.Title
                active={activeIndices.includes(index)} index={index} onClick={handleTitleClick}
                style={{
                  'display': 'flex', 'alignItems': 'center', 'justifyContent': 'space-between',
                  'padding': '10px', 'background': activeIndices.includes(index) ? '#f9f9f9' : 'white',
                }}
              >
                <div style={{'display': 'flex', 'alignItems': 'center', 'overflow': 'hidden'}}>
                  <Icon name="dropdown" />
                  <span style={{'fontWeight': 'bold', 'fontSize': '0.9em', 'textOverflow': 'ellipsis'}}>
                    {group.name}
                  </span>
                </div>
                <div style={{
                  'backgroundColor': '#767676', 'color': 'white',
                  'borderRadius': '10px', 'padding': '2px 8px',
                }}>
                  {group.items.length}
                </div>
              </Accordion.Title>
              <Accordion.Content active={activeIndices.includes(index)} style={{'padding': '0'}}>
                <List selection animated divided size="tiny" style={{'margin': '0'}}>
                  {group.items.map((ag) => {
                    const isSelected = Number(selectedId) === Number(ag.id);
                    const sInf = statusDict.find((item) => item.code === ag.status);
                    return (
                      <List.Item
                        key={ag.id} active={isSelected}
                        onClick={() => onSelect(isSelected ? null : ag.id)}
                        style={{'padding': '8px 15px !important', 'backgroundColor': isSelected ? '#e2f9e2' : ''}}
                      >
                        <List.Content floated="right" style={{'display': 'flex', 'gap': '5px'}}>
                          {isMatriculaUser && onView && (
                            <Button
                              icon="eye"
                              size="mini"
                              circular
                              color="blue"
                              basic
                              onClick={(e) => {
                                e.stopPropagation();
                                onView(ag);
                              }}
                            />
                          )}
                          {canEdit && onViewInscritos && (
                            <Button
                              icon="user"
                              size="mini"
                              circular
                              color="teal"
                              basic
                              onClick={(e) => {
                                e.stopPropagation();
                                onViewInscritos(ag);
                              }}
                            />
                          )}
                          {canEdit && onEdit && (
                            <Button
                              icon="pencil alternate"
                              size="mini"
                              circular
                              color="green"
                              basic
                              onClick={(e) => {
                                e.stopPropagation();
                                onEdit(ag);
                              }}
                            />
                          )}
                        </List.Content>
                        <Icon
                          name={isSelected ? 'check circle' : 'bookmark'}
                          style={{'color': isSelected ? '#21ba45' : (sInf?.hex || '#ccc'), 'marginTop': '8px'}}
                        />
                        <List.Content>
                          <List.Header style={{'fontSize': '0.85em'}}>
                            {moment.utc(ag.start_date || ag.desde).format('DD/MM')} -
                            {moment.utc(ag.end_date || ag.hasta).format('DD/MM')}
                          </List.Header>
                          <List.Description style={{'fontSize': '0.8em', 'color': '#999'}}>
                            ID: {ag.id}
                          </List.Description>
                        </List.Content>
                      </List.Item>
                    );
                  })}
                </List>
              </Accordion.Content>
            </React.Fragment>
          ))}
        </Accordion>
      </div>
    </Segment>
  );
};

export default CalendarSidebar;
